import type { ExtractPropTypes, PropType } from "vue";
import type Map from "./map.vue";

export interface TiandituGlobal {
  T?: any;
  __tdt_loaded?: boolean;
  __tdt_loading?: Promise<void> | null;
}

export const MapProps = {
  modelValue: {
    type: Array as unknown as PropType<[number, number, string] | []>,
    default: () => [],
  },
  options: {
    type: Object as PropType<{
      zoom?: number;
      zoomEnable?: boolean;
      dragEnable?: boolean;
    }>,
    default: () => ({
      zoom: 10,
      zoomEnable: true,
      dragEnable: true,
    }),
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String as PropType<"large" | "default" | "small">,
    default: "default",
  },
  placeholder: {
    type: String,
    default: "请选择坐标",
  },
  top: {
    type: String,
    default: "8vh",
  },
  width: {
    type: String,
    default: "100%",
  },
  type: {
    type: String,
    default: "edit",
  },
};

export type MapPropsType = ExtractPropTypes<typeof MapProps>;
export type MapInstance = InstanceType<typeof Map>;
